import { useEffect, useMemo, useRef } from 'react';
import { debounce } from 'lodash';
import hive from '@bombas/hive';
/**
 * Reusable hook to track slide changes only when a user has explicitly interacted with the images.
 * We debounce the event to avoid multiple rapid firings when user triggers carouseling across slides
 */
export var useTrackInteractedSlide = function (_a) {
    var current = _a.current, images = _a.images;
    var previousIndex = useRef(current);
    var debouncedSlideInView = useMemo(function () {
        return debounce(function (value) {
            hive.track('PRODUCT_IMAGE_CAROUSEL_UPDATE', {
                index: value,
                image: images[value].src
            });
        }, 500);
    }, [images]);
    useEffect(function () {
        var slideChanged = previousIndex.current !== current;
        if (slideChanged) {
            debouncedSlideInView(current);
            previousIndex.current = current;
        }
    }, [current]);
    return {
        /**
         * Must be called whenever the slide index is reset (e.g. when images change)
         * This is crucial as it prevents fasely tracking an interacted image change when a user navigates across color variants.
         */
        reset: function () {
            previousIndex.current = 0;
        }
    };
};
export default {};
